












































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { ISBAsset } from '@shared/types/storyblok';

import BrandCard from '~/components/BrandCard/BrandCard.vue';
import CardSection from '~/components/CardSection/CardSection.vue';
import Container from '~/components/Container.vue';
import useBikeFinderModal from '~/composables/useBikeFinderModal';

interface IMakeStory {
  uuid: string;
  slug: string;
  content: {
    title: string;
    banner_image?: ISBAsset;
  };
}

export default defineComponent({
  name: 'MakesCarousel',
  components: {
    CardSection,
    BrandCard,
    Container,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    makes: {
      type: Array as PropType<IMakeStory[]>,
      default: () => [],
    },
  },
  setup() {
    const getMakeUrl = (slug: string) => `/bikes/${slug}`;
    const { interceptMakeClick } = useBikeFinderModal();

    return { getMakeUrl, interceptMakeClick };
  },
});
